import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// non-dojo deps kept: ActionBar used as a value (new); the three lists are only referenced via the
// template / define contract → bare side-effect imports.
import "./EmploymentList";
import "./MusicianList";
import "./TravelExpenseList";
import ActionBar from './ActionBar';
import template from './templates/MusicianProjectsMain.html?raw';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
// NOTE (JS2TS): dropped dead dojo dep (_base/connect). DOM-heavy → dom-construct aliased.
// $ (jQuery) is a runtime global used verbatim by the original; declared ambiently here.
declare const $: any;

const domConstruct: any = domConstructTyped;

class MusicianProjectsMain extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    currentLoadedProjectItems: any = null;

    startup(): void {
        this.loadMusicanProjects();
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    _selectionItemClick(e: any): void {
        //console.log("_selectionItemClick", this.currentLoadedProjectItems, e.target);

        for (var i = 0; i < this.currentLoadedProjectItems.length; i++) {
            var item = this.currentLoadedProjectItems[i];

            if (item.input_name == e.target.name) {
                console.log(item.ProjectDescription, e.target.value);

                item.DutyTypeCode = e.target.value;

                //spinners.global().spin(document.getElementById('spinner_box'));
                this.StandbyStart()

                //var url = window.appRoot + "Orchestra/SetDispoValue";
                var url = window.appRoot + "SOV/OrchestraSetDispoValueJSON";


                this.RequestManager.post(
                    url,
                    {
                        item: JSON.stringify(item)
                    },
                    lang.hitch(this, "_onSelectionItemClickResponse", e),
                    lang.hitch(this, "_onSelectionItemClickError", e),
                    false // sync
                );
            }
        }
    }

    _onSelectionItemClickResponse(e: any, response: any): void {
        //spinners.global().stop();
        this.StandbyStop();

        if (response.Exception == undefined) {
            var elem = $('#' + e.target.name + "_system_message");
            elem.html("gespeichert!");
            elem.css("color", "green");

            for (var itemIndex = 0; itemIndex < this.currentLoadedProjectItems.length; itemIndex++) {
                if (this.currentLoadedProjectItems[itemIndex].ref_ev_project == response.ref_ev_project &&
                    this.currentLoadedProjectItems[itemIndex].ref_engagement == response.ref_engagement) {
                    response.input_name = this.currentLoadedProjectItems[itemIndex].input_name;
                    this.currentLoadedProjectItems[itemIndex] = response;

                    this._setRadioInputValue(this.currentLoadedProjectItems[itemIndex]);
                    break;
                }
            }
        } else {
            var elem = $('#' + e.target.name + "_system_message");
            elem.html("Fehler beim Speichern! " + response.Message);
            elem.css("color", "red");
        }
    }

    _onSelectionItemClickError(e: any, error: any): void {
        //spinners.global().stop();
        this.StandbyStop();
        //console.log("_onSelectionItemClickError", error, e);
        var elem = $('#' + e.target.name + "_system_message");
        //elem.html("Allgemeiner Fehler beim Speichern! Bitte Seite neu laden.");
        elem.html("Fehler beim Speichern: " + error.Message);
        elem.css("color", "red");
    }

    _setRadioInputValues(): void {
        if (this.currentLoadedProjectItems == null) {
            return;
        }

        for (var x = 0; x < this.currentLoadedProjectItems.length; x++) {
            this._setRadioInputValue(this.currentLoadedProjectItems[x]);
        }
    }

    _setRadioInputValue(item: any): void {
        $("#" + item.input_name + item.DutyTypeCode).prop("checked", true);
    }

    loadMusicanProjects(): void {

        //spinners.global().spin(document.getElementById('spinner_box'));
        this.StandbyStart();
        //console.log("_onLoadCurrentPeriodResponse", response);
        var url = window.appRoot + "SOV/OrchestraGetMusicanProjects";

        this.RequestManager.post(
            url,
            {
            },
            lang.hitch(this, "_onLoadMusicanProjectsResponse"),
            lang.hitch(this, "_onLoadMusicanProjectsError"),
            false // sync
        );
    }

    _onLoadCurrentPeriodError(error: any): void {
        //console.log("_onLoadCurrentPeriodError", error);
        //spinners.global().stop();
        this.StandbyStop();
    }

    _onLoadMusicanProjectsResponse(response: any): void {

        console.log("_onLoadMusicanProjectsResponse", response);

        //vorberechnen ob stimmeinteiler-spalte angezeigt werden soll
        //
        var functionhead_enabled = false;
        var extraColumn = 0; // Extraspalte für die Stimmführereinteilung, wenn bei einem der Items diese schon veröffentlicht ist
        for (var i = 0; i < response.length; i++) {
            var item = response[i];
            if (item.is_planned_by_functionhead === 1) {
                functionhead_enabled = true;
            }

            if (functionhead_enabled) {
                extraColumn = 1;
            }
        }

        let functionLabel = "-";
        if (item) {
            functionLabel = item.FunctionLabel;
        }

        domConstruct.empty(this.tableNode);

        var table = document.createElement('table');
        table.className = "SOV_projecttable";



        var tBody = document.createElement("tbody");
        table.appendChild(tBody);

        this.currentLoadedProjectItems = response;

        var currentPeriod = null;

        for (var i = 0; i < response.length; i++) {
            var item = response[i];
            var jsonDataProject = null;

            try {
                jsonDataProject = JSON.parse(item.projectJsonData);
            } catch (ex) {
                console.warn("error parsing projectJson", ex, item.projectJsonData);
            }

            // Extrazeile mit Saisonwechsel!
            if (item.ProjectArtisticPeriodID != currentPeriod) {
                var row = tBody.insertRow(-1);
                var col = row.insertCell(-1);
                col.innerHTML = "Saison: " + item.ProjectArtisticPeriodDescription;

                domClass.add(col, "w3-center seasonHeader");
                domClass.add(col, "sticky");

                col.colSpan = 4 + extraColumn;

                currentPeriod = item.ProjectArtisticPeriodID

                if (i > 0) {
                    domAttr.set(this.currentPeriodLabel, "innerHTML", "mehrere Saisonen");
                } else {
                    domAttr.set(this.currentPeriodLabel, "innerHTML", item.ProjectArtisticPeriodDescription);
                }

                let hrow = tBody.insertRow(-1);
                hrow.className = "secondHeader sticky";
                hrow.insertCell(-1).innerHTML = "Zeitraum<br>Funktion";
                hrow.insertCell(-1).innerHTML = "Beschreibung";
                // Funktion kommt vom Webuser (quasi das eigentliche Engagement) und ändert sich nicht pro Projekt

                hrow.insertCell(-1).innerHTML = "Meine Anmeldung<br>(" + functionLabel + ")";
                if (functionhead_enabled) {
                    hrow.insertCell(-1).innerHTML = "Einteilung (Stimmführer)";
                }
                hrow.insertCell(-1).innerHTML = "Eingeteilt für Projekt";
            }


            var bShowDetails = item.bShowActionBar === true;
            var myDutyType = item.DutyTypeCode;
            var functionHeadDutyType = item.DutyTypeCode_2;

            var row = tBody.insertRow(-1);
            var col = row.insertCell(-1);
            col.innerHTML = item.TimeRange;

            // wieso sollte die Funktion da überhaupt dargestellt werden, ist ja eh immer das gleiche Engagement... nicht?
            // Anruf aus 2022: tatsächlich NICHT. und schon haben wir die ersten Fälle mit übersteuertem Engagement/Funktin...
            if (item.SubFunction != null) {
                if (item.SubFunction != functionLabel) {
                    let div = document.createElement("div");
                    col.appendChild(div);
                    div.innerHTML = item.SubFunction;
                    div.className = "actualFunctionname";
                }
            }

            var system_message = document.createElement("div");
            system_message.id = "selection_" + i + "_system_message";

            // Zebramuster (manuell, weil mehrere trs pro Datensatz vorkommen können...)
            var bgClass = i % 2 == 1 ? "ping" : "pong";
            domClass.add(row, bgClass);

            col.appendChild(system_message);

            col = row.insertCell(-1);
            col.innerHTML = item.ProjectDescription;

            var dutyValues = [{ label: "k.A", code: "null" }, { label: "X", code: "X" }];
            var dutyValuesHead = [{ label: "k.A", code: "null" }, { label: "X", code: "X" }, { label: "R", code: "R" }];

            // meine anmeldung
            //
            col = row.insertCell(-1);


            for (var d = 0; d < dutyValues.length; d++) {
                var value = dutyValues[d];
                var div = document.createElement("div");

                var input = document.createElement("input");
                input.type = "radio";
                input.id = "selection_" + i + value.code;
                input.name = "selection_" + i;
                input.value = value.code;

                on(input, "click", lang.hitch(this, "_selectionItemClick"));
                //$(input).bind('click', evisDataManager._selectionItemClick);


                if (value.code == "null")
                    input.checked = true;

                if (value.code == myDutyType) {
                    input.checked = true;
                }

                var label = document.createElement("label");
                label.innerHTML = value.label;
                label.htmlFor = input.id;

                div.appendChild(input);
                div.appendChild(label);
                col.appendChild(div);

                // #22914
                if (jsonDataProject && jsonDataProject.lvlDispoMusician != 2) {
                    domClass.add(div, "w3-disabled opaque");
                }

                item.input_name = input.name;
            }



            if (functionhead_enabled) {//=== 1) {
                // stimmführer einteilung
                //

                col = row.insertCell(-1);

                //if (bShowDetails === true) {
                if (true) {
                    for (var d = 0; d < dutyValuesHead.length; d++) {
                        var value = dutyValuesHead[d];
                        var div = document.createElement("div");
                        domClass.add(div, "w3-disabled opaque");
                        var input = document.createElement("input");
                        input.type = "radio";
                        input.id = "my_selection_" + i + value.code;
                        input.name = "my_selection_" + i;
                        input.value = value.code;
                        $(input).attr("disabled", true);


                        domStyle.set(input, "cursor", "default");

                        if (value.code == "null") {
                            input.checked = true;
                        }

                        if (value.code == functionHeadDutyType) {
                            input.checked = true;
                        }

                        var label = document.createElement("label");
                        label.innerHTML = value.label;
                        label.htmlFor = input.id;


                        div.appendChild(input);
                        div.appendChild(label);
                        col.appendChild(div);
                    }
                }

            }


            // hab ich aktuell tatsächlich Dienste?
            if (jsonDataProject) {
                var dutyValues = [{ label: "ja", code: "true" }, { label: "nein", code: "false" }];
                var dutyCol = row.insertCell(-1);

                for (var d = 0; d < dutyValues.length; d++) {
                    var value = dutyValues[d];
                    var div = document.createElement("div");
                    domClass.add(div, "w3-disabled opaque");
                    var input = document.createElement("input");
                    input.type = "radio";
                    input.id = "hasDuties_" + i + value.code;
                    input.name = "hasDuties_" + i;
                    input.value = value.code;

                    input.checked = value.code == jsonDataProject.bHasDutiesPlanned.toString();

                    var label = document.createElement("label");
                    label.innerHTML = value.label;
                    label.htmlFor = input.id;

                    div.appendChild(input);
                    div.appendChild(label);
                    dutyCol.appendChild(div);
                }

                //if (jsonDataProject.bHasDutiesPlanned) {
                //    let actualFunctionLabel = jsonDataProject.actualFunctionLabel;

                //    if (actualFunctionLabel && actualFunctionLabel != functionLabel) {
                //        let container = document.createElement("div");
                //        let label = document.createElement("span");
                //        label.innerHTML = actualFunctionLabel;
                //        container.appendChild(label);
                //        dutyCol.appendChild(container);
                //    }
                //}

            }


            // erweiterte Features einblenden oder nicht
            if (bShowDetails === true) {

                row = tBody.insertRow(-1);
                col = row.insertCell(-1);
                col.colSpan = 4 + extraColumn;
                var extra_message = document.createElement("div");
                extra_message.id = "selection_" + i + "_extra_message";

                // Zebramuster (manuell, weil mehrere trs pro Datensatz vorkommen können...)
                domClass.add(row, bgClass);


                // Buttonleiste einblenden
                var actionBar = new ActionBar();
                actionBar.item = item;

                domConstruct.place(actionBar.domNode, col);

                //domStyle.set(expList.domNode, "width", "95%");
                domStyle.set(actionBar.domNode, "margin", "auto");

                actionBar.startup();

            }
        }

        domConstruct.place(table, this.tableNode);
        this._setRadioInputValues();


        //spinners.global().stop();
        this.StandbyStop();
    }

    _onLoadMusicanProjectsError(error: any): void {
        console.error("_onLoadMusicanProjectsError", error);

        //this._setRadioInputValues();
        //spinners.global().stop();
        this.StandbyStop();
    }
}
MusicianProjectsMain.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.MusicianProjectsMain';

export default mdsWidget(MusicianProjectsMain);
